import { Component, inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakAuthService } from '@dss-libs/shared/data-access/auth';
import { IError, SessionStorageConstants } from '@dss-libs/shared/type/common-types';
import { UserManagementService } from '@dss-libs/shared/data-access/users';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class PostInviteComponent {
  private readonly keycloakAuthService = inject(KeycloakAuthService);
  route = inject(ActivatedRoute);
  router = inject(Router);
  userManagementService = inject(UserManagementService);
  document = inject(DOCUMENT);

  constructor() {
    const invitationToken = this.route.snapshot.queryParams['invitationToken'] ?? this.readStoredInvitationToken();
    if (!invitationToken) return;
    this.storeInvitationToken(invitationToken);

    this.userManagementService.linkInvitedUser(invitationToken).subscribe({
      next: () => {
        this.clearStoredInvitationToken();
        window.location.replace(this.document.location.origin);
      },
      error: (err: IError) => {
        if (err.status === 400) {
          this.keycloakAuthService.logout(this.constructErrorRedirectUrl(err));
        }
      },
    });
  }

  private readStoredInvitationToken(): string | null {
    return window.sessionStorage.getItem(SessionStorageConstants.InvitationToken);
  }

  private storeInvitationToken(token: string): void {
    window.sessionStorage.setItem(SessionStorageConstants.InvitationToken, token);
  }

  private clearStoredInvitationToken(): void {
    window.sessionStorage.removeItem(SessionStorageConstants.InvitationToken);
  }

  private constructErrorRedirectUrl(err: IError) {
    const errorMessage = err.error.validationErrors[0].errors[0];
    const redirectUri = `/postInvite?errorMessage=${encodeURIComponent(errorMessage)}`;
    return `${this.document.location.origin}/login?redirectUri=${encodeURIComponent(redirectUri)}`;
  }
}
